/*
 * Radiance Veil collection pages: front-end "View 3 / 4 / 6" density toggle.
 *
 * The theme's own "Columns (desktop)" setting (2-5) only sets the *default* grid — this adds a
 * shopper-facing control that overrides it live, remembered across the site via localStorage.
 * Uses event delegation and a MutationObserver so it keeps working after the filter bar or
 * product grid gets replaced by the theme's own AJAX filtering/sorting/infinite-scroll, without
 * needing to know when that happens.
 */
(function () {
  var STORAGE_KEY = 'rv-collection-columns';

  function applyColumns(value) {
    document.querySelectorAll('[data-section-type="collection"]').forEach(function (section) {
      section.style.setProperty('--collection-columns-desktop', value);
    });
    // Search results page: its grid reads --search-columns-desktop, set inline on an inner
    // element of the search section (so it has to be overridden there, not on the section).
    document.querySelectorAll('[data-section-type="search"], [data-section-type="search"] [style*="--search-columns-desktop"]').forEach(function (el) {
      el.style.setProperty('--search-columns-desktop', value);
    });
    document.querySelectorAll('[data-view-toggle]').forEach(function (toggle) {
      toggle.querySelectorAll('[data-view-columns]').forEach(function (btn) {
        btn.classList.toggle('is-active', btn.getAttribute('data-view-columns') === String(value));
      });
    });
  }

  function initToggle(toggle) {
    if (toggle.__rvInit) return;
    toggle.__rvInit = true;

    var saved = null;
    try {
      saved = window.localStorage.getItem(STORAGE_KEY);
    } catch (e) {}

    if (saved) {
      applyColumns(saved);
    } else {
      var section = toggle.closest('[data-section-type="collection"], [data-section-type="search"]');
      var current = section && section.getAttribute('data-collection-columns-desktop');
      if (current && toggle.querySelector('[data-view-columns="' + current + '"]')) {
        applyColumns(current);
      }
    }
  }

  function init() {
    document.querySelectorAll('[data-view-toggle]').forEach(initToggle);
  }

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-view-columns]');
    if (!btn) return;
    var value = btn.getAttribute('data-view-columns');
    applyColumns(value);
    try {
      window.localStorage.setItem(STORAGE_KEY, value);
    } catch (e) {}
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init (and re-apply the saved/active state) whenever the filter bar or grid is
  // replaced — covers the theme's own AJAX filtering, sorting, and infinite scroll.
  var observer = new MutationObserver(function () {
    init();
  });
  observer.observe(document.body, { childList: true, subtree: true });
})();

/*
 * Default product page: move the "Size Chart" link (a custom_liquid block, rendered as its own
 * top-level product block) to the far right of the "Quantity" label line (or, without a Quantity
 * label, directly above the Size option row), instead of its normal
 * position below the whole color/size variant picker. It can't be done with CSS `order` alone
 * because Color and Size are two options rendered *inside* the same variant-picker block, not
 * separate top-level blocks — so the trigger is physically moved in the DOM, at every screen
 * width, and only within the default product template's variant picker.
 */
(function () {
  function findSizeOption(variantsWrapper) {
    var options = variantsWrapper.querySelectorAll('[data-product-option]');
    for (var i = 0; i < options.length; i++) {
      var label = options[i].querySelector('.product__label');
      if (label && label.textContent.trim().toLowerCase().indexOf('size') === 0) {
        return options[i];
      }
    }
    return null;
  }

  function moveSizeChartLinks() {
    document.querySelectorAll('.product__meta').forEach(function (meta) {
      var trigger = meta.querySelector('.rv-size-chart-trigger');
      var chartBlock = trigger && trigger.closest('.product-block-custom-liquid');
      if (!chartBlock) return;

      // New product page (assets/rv-pdp.js, 2026-11-01): far right on the "Size" label line, as "Size guide".
      if (document.querySelector('[data-rv-pdp2]')) {
        var vw = meta.querySelector('.product__variants-wrapper');
        var so = vw && findSizeOption(vw);
        var sizeLabelRow = so && so.querySelector('.product__label-wrapper');
        if (sizeLabelRow) {
          if (chartBlock.parentNode !== sizeLabelRow) sizeLabelRow.appendChild(chartBlock);
          if (!chartBlock.hasAttribute('data-rv-size-chart-size')) chartBlock.setAttribute('data-rv-size-chart-size', 'true');
          return;
        }
      }

      // Preferred spot: far right on the "Quantity" label line (the label row becomes a flex row,
      // see rv-collection.css). Falls back to above the Size row when there's no Quantity label.
      var qtyLabelRow = meta.querySelector('.product__controls-group-quantity .product__label-wrapper:not(.product__label-wrapper--collapse)');
      if (qtyLabelRow) {
        if (chartBlock.parentNode !== qtyLabelRow) qtyLabelRow.appendChild(chartBlock);
        if (!chartBlock.hasAttribute('data-rv-size-chart-qty')) chartBlock.setAttribute('data-rv-size-chart-qty', 'true');
        return;
      }

      var variantsWrapper = meta.querySelector('.product__variants-wrapper');
      if (!variantsWrapper) return;
      var sizeOption = findSizeOption(variantsWrapper);
      // Only move when it isn't already in place: every insert fires a childList mutation,
      // which re-triggers the observer below, so an unconditional move would loop forever.
      if (sizeOption && sizeOption.previousElementSibling !== chartBlock) {
        sizeOption.parentNode.insertBefore(chartBlock, sizeOption);
      }
      if (sizeOption && !chartBlock.hasAttribute('data-rv-size-chart-moved')) {
        chartBlock.setAttribute('data-rv-size-chart-moved', 'true');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', moveSizeChartLinks);
  } else {
    moveSizeChartLinks();
  }

  // The Size Chart popup is rendered inside the product section, a stacking context below the
  // header, so on its own it can never cover the header however high its z-index is. Just before
  // the trigger's own onclick opens it (capture phase runs first), move it to <body>, where its
  // z-index applies against the whole page. Its open/close handlers and scripts all find it by
  // id, so they keep working after the move.
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest && event.target.closest('.rv-size-chart-trigger');
    if (!trigger) return;
    var block = trigger.closest('.product-block-custom-liquid') || trigger.parentNode;
    var modal = block.querySelector('.rv-size-chart-modal');
    if (!modal) return;
    // A re-rendered block brings a fresh copy; drop any earlier one already moved to <body>.
    document.querySelectorAll('body > .rv-size-chart-modal').forEach(function (old) {
      if (old !== modal) old.remove();
    });
    document.body.appendChild(modal);

    // Mirror the popup's open state onto <html> (see rv-collection.css) — its own inline
    // handlers only toggle .is-open on the popup itself.
    if (!modal.__rvOpenObserver) {
      modal.__rvOpenObserver = new MutationObserver(syncSizeChartOpen);
      modal.__rvOpenObserver.observe(modal, { attributes: true, attributeFilter: ['class'] });
    }
  }, true);

  // iOS Safari doesn't reliably stop touch scrolling with overflow:hidden alone, and any page
  // scroll behind the popup is what brings the header back into view. Pinning <body> in place
  // (position:fixed at the current offset) is the lock iOS can't scroll through; the exact
  // scroll position is restored on close.
  var lockedScrollY = null;

  function syncSizeChartOpen() {
    var open = !!document.querySelector('.rv-size-chart-modal.is-open');
    var html = document.documentElement;
    var body = document.body;
    html.classList.toggle('rv-size-chart-open', open);

    if (open && lockedScrollY === null) {
      lockedScrollY = html.scrollTop || body.scrollTop || window.pageYOffset || 0;
      body.style.position = 'fixed';
      body.style.top = -lockedScrollY + 'px';
      body.style.left = '0';
      body.style.right = '0';
      body.style.width = '100%';
    } else if (!open && lockedScrollY !== null) {
      body.style.position = '';
      body.style.top = '';
      body.style.left = '';
      body.style.right = '';
      body.style.width = '';
      html.scrollTop = lockedScrollY;
      body.scrollTop = lockedScrollY;
      lockedScrollY = null;
    }
  }

  // Re-apply after the variant picker is re-rendered (variant change, theme editor reloads).
  var sizeChartObserver = new MutationObserver(function () {
    moveSizeChartLinks();
  });
  sizeChartObserver.observe(document.body, { childList: true, subtree: true });
})();

/*
 * Product page "Like it? Share" row (snippets/rv-share-inline.liquid): each link opens that site's
 * share window, with this product's link, name and image already filled in, as a small centered
 * pop-up so the shopper stays on the product page. If the pop-up is blocked, the link's own
 * target="_blank" opens it in a new tab instead.
 */
(function () {
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-rv-share-popup]');
    if (!link) return;
    var width = 600;
    var height = 640;
    var left = Math.max(0, (window.screenX || 0) + (window.outerWidth - width) / 2);
    var top = Math.max(0, (window.screenY || 0) + (window.outerHeight - height) / 2);
    var popup = window.open(link.href, 'rv-share', 'width=' + width + ',height=' + height + ',left=' + left + ',top=' + top + ',scrollbars=yes,resizable=yes');
    if (popup) {
      event.preventDefault();
      try { popup.opener = null; popup.focus(); } catch (error) {}
    }
  });
})();

/*
 * Product highlights icons (snippets/product-block-highlights.liquid): every icon uploaded to a Product
 * Highlight — now and in the future — is cleaned up in the browser so they all look the same: a plain
 * background (white, gray, any flat color sampled from the corners) becomes transparent with soft edges
 * kept, and the empty space around the drawing is trimmed so each icon fills the same square. Icons are
 * served from the store's own domain, so the canvas can read them; if one can't be read it's left as is
 * (the CSS in rv-collection.css still blends a light background into the page).
 */
(function () {
  var MAX = 360;

  function corners(px, w, h) {
    var points = [0, (w - 1) * 4, (h - 1) * w * 4, ((h - 1) * w + w - 1) * 4];
    return points.map(function (i) { return [px[i], px[i + 1], px[i + 2], px[i + 3]]; });
  }

  function clean(img) {
    if (img.dataset.rvCleaned) return;
    img.dataset.rvCleaned = '1';
    try {
      var scale = Math.min(1, MAX / Math.max(img.naturalWidth, img.naturalHeight));
      var w = Math.max(1, Math.round(img.naturalWidth * scale));
      var h = Math.max(1, Math.round(img.naturalHeight * scale));
      var canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = h;
      var ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0, w, h);
      var data = ctx.getImageData(0, 0, w, h);
      var px = data.data;

      // Background: the corners' average, if they're opaque and alike (otherwise it's already transparent).
      var c = corners(px, w, h);
      var opaque = c.every(function (p) { return p[3] > 240; });
      var alike = c.every(function (p) { return Math.abs(p[0] - c[0][0]) + Math.abs(p[1] - c[0][1]) + Math.abs(p[2] - c[0][2]) < 30; });
      if (opaque && alike) {
        var bg = [0, 1, 2].map(function (k) { return (c[0][k] + c[1][k] + c[2][k] + c[3][k]) / 4; });
        for (var i = 0; i < px.length; i += 4) {
          var diff = Math.max(Math.abs(px[i] - bg[0]), Math.abs(px[i + 1] - bg[1]), Math.abs(px[i + 2] - bg[2]));
          var a = Math.min(1, Math.max(0, (diff - 6) / 70));
          if (a > 0) {
            // un-mix the background so edges keep their true color
            for (var k = 0; k < 3; k++) px[i + k] = Math.max(0, Math.min(255, Math.round(bg[k] + (px[i + k] - bg[k]) / a)));
          }
          px[i + 3] = Math.round(a * (px[i + 3] / 255) * 255);
        }
        ctx.putImageData(data, 0, 0);
      }

      // Trim to the drawing, square it with a little breathing room.
      var minX = w, minY = h, maxX = -1, maxY = -1;
      for (var y = 0; y < h; y++) {
        for (var x = 0; x < w; x++) {
          if (px[(y * w + x) * 4 + 3] > 20) {
            if (x < minX) minX = x;
            if (x > maxX) maxX = x;
            if (y < minY) minY = y;
            if (y > maxY) maxY = y;
          }
        }
      }
      if (maxX < 0) return;
      var tw = maxX - minX + 1, th = maxY - minY + 1;
      var side = Math.round(Math.max(tw, th) * 1.06);
      var out = document.createElement('canvas');
      out.width = side;
      out.height = side;
      out.getContext('2d').drawImage(canvas, minX, minY, tw, th, Math.round((side - tw) / 2), Math.round((side - th) / 2), tw, th);
      img.removeAttribute('srcset');
      img.removeAttribute('sizes');
      img.src = out.toDataURL('image/png');
      img.closest('.rv-product-highlights__icon').classList.add('rv-product-highlights__icon--clean');
    } catch (error) {
      // unreadable image (e.g. another domain): keep the original
    }
  }

  function prepare(root) {
    (root || document).querySelectorAll('.rv-product-highlights__icon img').forEach(function (img) {
      if (img.dataset.rvCleaned) return;
      if (img.complete && img.naturalWidth) clean(img);
      else img.addEventListener('load', function () { clean(img); }, { once: true });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { prepare(); });
  else prepare();
  document.addEventListener('shopify:section:load', function (event) { prepare(event.target); });
  new MutationObserver(function (records) {
    for (var r = 0; r < records.length; r++) {
      if (records[r].addedNodes.length) { prepare(); return; }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/*
 * Shop By Category (snippets/shop-by-category.liquid, a <details> dropdown on collection pages).
 * Phones: opens as a full-screen popup. The panel is moved to <body> while open, since the filter
 * bar / section around it are sticky stacking contexts that would keep it under the header and
 * let the page show through; it goes back into its <details> on close. html.rv-sbc-open locks
 * the page behind it. Desktop: stays a dropdown, closed by the X, Escape or a click outside.
 * Styles: assets/rv-collection.css.
 */
(function () {
  var open = null; // { details, panel, marker }

  function isPhone() { return window.innerWidth <= 749; }

  function close() {
    if (!open) return;
    var o = open;
    open = null;
    if (o.marker && o.marker.parentNode) {
      o.marker.parentNode.insertBefore(o.panel, o.marker);
      o.marker.remove();
    }
    o.panel.classList.remove('is-popup');
    document.documentElement.classList.remove('rv-sbc-open');
    o.details.removeAttribute('open');
  }

  document.addEventListener('toggle', function (event) {
    var details = event.target;
    if (!details.classList || !details.classList.contains('shop-by-category-dropdown')) return;
    if (!details.open) {
      if (open && open.details === details) close();
      return;
    }
    if (open && open.details !== details) close();
    var panel = details.querySelector('.shop-by-category-panel');
    if (!panel) return;
    open = { details: details, panel: panel, marker: null };
    if (isPhone()) {
      open.marker = document.createComment('shop-by-category-panel');
      panel.parentNode.insertBefore(open.marker, panel);
      document.body.appendChild(panel);
      panel.classList.add('is-popup');
      document.documentElement.classList.add('rv-sbc-open');
    }
  }, true);

  document.addEventListener('click', function (event) {
    if (!open) return;
    if (event.target.closest('[data-sbc-close]')) {
      event.preventDefault();
      close();
      return;
    }
    if (!open.panel.contains(event.target) && !open.details.contains(event.target)) close();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') close();
  });
})();

/*
 * Product page "Complete The Look" (featured products block): a slider on desktop too, like the
 * store's other product sliders — 3 cards in view, arrows over the sides (rendered by
 * product-block-featured-products.liquid). The theme only runs a slider below 720px (2.1 cards)
 * and destroys it above, so this one runs only from 720px up and is destroyed below, leaving the
 * phone slider to the theme. Left-column blocks are rendered twice (desktop + a .for-mobile copy,
 * the one shown from 720px to 959px); both get the slider.
 *
 * Swiper is the theme's own chunk (window.flu.chunks.swiper). A failed load or start is retried
 * (on the next DOM change / load / resize) instead of leaving the cards stuck as a grid.
 */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 720px)');
  var swiperModule = null;
  var failures = 0;   // stop retrying after a few failed starts

  // Loaded through an injected <script type="module">, not import(): Shopify's CDN minifier
  // rewrites import() in theme assets into require(), which doesn't exist in browsers (it works
  // on the theme dev server, which serves the file as written, and silently fails everywhere else).
  function loadSwiper() {
    if (!swiperModule) {
      if (!window.flu || !window.flu.chunks || !window.flu.chunks.swiper) {
        return Promise.reject(new Error('swiper chunk url not ready'));
      }
      swiperModule = new Promise(function (resolve, reject) {
        var id = 'rvCtlSwiper' + Date.now();
        window[id] = function (mod) {
          delete window[id];
          if (mod) resolve(mod); else reject(new Error('swiper chunk failed to load'));
        };
        var script = document.createElement('script');
        script.type = 'module';
        script.textContent = 'import(' + JSON.stringify(window.flu.chunks.swiper) + ').then(function (m) { window.' + id + '(m); }, function () { window.' + id + '(null); });';
        document.head.appendChild(script);
      }).catch(function (error) {
        swiperModule = null;
        throw error;
      });
    }
    return swiperModule;
  }

  function init(container) {
    if (container.__rvCtlSwiper || failures >= 3) return;
    if (!container.querySelector('.swiper-wrapper')) return;
    container.__rvCtlSwiper = 'loading';
    loadSwiper().then(function (mod) {
      if (container.__rvCtlSwiper !== 'loading' || !DESKTOP.matches) {
        if (container.__rvCtlSwiper === 'loading') container.__rvCtlSwiper = null;
        return;
      }
      // A slider left on the element (theme editor re-render, theme's phone slider) is replaced.
      if (container.swiper && container.swiper.destroy) container.swiper.destroy(true, true);
      container.classList.add('rv-ctl-swiper');
      container.__rvCtlSwiper = new mod.Swiper(container, {
        modules: [mod.Navigation],
        slidesPerView: 3,
        spaceBetween: 16,
        grabCursor: true,
        watchSlidesProgress: true,
        watchOverflow: true,
        observer: true,
        observeParents: true,
        navigation: {
          nextEl: container.querySelector('.rv-ctl-nav [data-next]'),
          prevEl: container.querySelector('.rv-ctl-nav [data-prev]')
        }
      });
    }).catch(function (error) {
      failures++;
      container.__rvCtlSwiper = null;
      container.classList.remove('rv-ctl-swiper');
      if (window.console) console.warn('Complete The Look slider:', error);
    });
  }

  function destroy(container) {
    var swiper = container.__rvCtlSwiper;
    container.__rvCtlSwiper = null;
    if (swiper && swiper !== 'loading') swiper.destroy(true, true);
    container.classList.remove('rv-ctl-swiper');
  }

  function update() {
    document.querySelectorAll('.product__block-featured-products [data-featured-products]').forEach(function (container) {
      if (DESKTOP.matches) {
        init(container);
      } else if (container.__rvCtlSwiper) {
        destroy(container);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', update);
  } else {
    update();
  }
  if (DESKTOP.addEventListener) {
    DESKTOP.addEventListener('change', update);
  }
  window.addEventListener('load', update);
  window.addEventListener('resize', update);
  // App recommendations are fetched in after load, and the theme editor re-renders sections.
  // Changes inside a running slider (Swiper's own) are ignored.
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var target = mutations[i].target;
      if (target.closest && target.closest('.rv-ctl-swiper')) continue;
      if (document.querySelector('.product__block-featured-products [data-featured-products]')) update();
      return;
    }
  }).observe(document.body, { childList: true, subtree: true });
})();

/*
 * Phones only: hide the scroll-to-top button while any pop-up is open (quick view, cart drawer, menu,
 * search, size chart, newsletter/age pop-ups, chat window, app pop-ups) so it never sits on top of them.
 * Sets html.rv-popup-open; the hiding itself is in rv-collection.css (max-width: 719px).
 */
(function () {
  var html = document.documentElement;
  var mq = window.matchMedia('(max-width: 719px)');
  var pending = false;

  function bigOverlay(el) {
    var cs = getComputedStyle(el);
    if (cs.position !== 'fixed' || cs.display === 'none' || cs.visibility === 'hidden' || parseFloat(cs.opacity) < 0.1) return false;
    if (el.matches('.back-to-top, header, .header, [class*="sticky-atc"], [class*="announcement"]')) return false;
    var r = el.getBoundingClientRect();
    return r.width >= window.innerWidth * 0.6 && r.height >= window.innerHeight * 0.4;
  }

  function popupOpen() {
    var body = document.body;
    if (body.getAttribute('data-fluorescent-overlay-open') === 'true') return true;
    if (html.classList.contains('rv-size-chart-open') || document.querySelector('.rv-size-chart-modal.is-open')) return true;
    if (document.querySelector('.popup.visible, .modal.is-visible, .quick-product--wrap.is-visible, .drawer.is-visible, [role="dialog"][aria-hidden="false"]')) return true;
    // app pop-ups (chat window, review/wishlist/discount pop-ups) are usually fixed layers on <body>
    var kids = body.children;
    for (var i = 0; i < kids.length; i++) if (bigOverlay(kids[i])) return true;
    return false;
  }

  function update() {
    pending = false;
    html.classList.toggle('rv-popup-open', mq.matches && popupOpen());
  }
  function schedule() { if (!pending) { pending = true; requestAnimationFrame(update); } }

  new MutationObserver(schedule).observe(document.documentElement, { attributes: true, childList: true, subtree: true, attributeFilter: ['class', 'style', 'aria-hidden', 'data-fluorescent-overlay-open', 'open'] });
  window.addEventListener('resize', schedule);
  document.addEventListener('click', function () { setTimeout(schedule, 400); }, true);
  schedule();
})();
